export default "__VITE_ASSET__6c2ee50d__"